module.exports = "/static/assets/df119834537bf98c8c02f09b1dc40b63.png";